import React, { useEffect, useState, useContext } from 'react';
import { ConsultaSessoesMemoria, RevogaSessaoMemoria } from '../../lib/api';
import { GlobalContext } from '../../lib/GlobalVar';
import Swal from 'sweetalert2';

function tempo(ms) {
    if (!ms) return '-';
    const d = new Date(ms);
    return d.toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo' });
}

function relativo(ms) {
    if (!ms) return '-';
    const diff = Date.now() - ms;
    const m = Math.floor(diff / 60000);
    if (m < 1) return 'agora';
    if (m < 60) return `${m}min atras`;
    const h = Math.floor(m / 60);
    if (h < 24) return `${h}h atras`;
    const d = Math.floor(h / 24);
    return `${d}d atras`;
}

export default function TISessoesMemoria() {
    const { user: me } = useContext(GlobalContext);
    const [sessoes, setSessoes] = useState([]);
    const [carregando, setCarregando] = useState(false);
    const [erro, setErro] = useState('');
    const [filtroAtivos, setFiltroAtivos] = useState(true);

    useEffect(() => { carregar(); }, []);

    async function carregar() {
        setCarregando(true);
        setErro('');
        const r = await ConsultaSessoesMemoria({});
        setCarregando(false);
        if (r.Error) { setErro(r.Error); setSessoes([]); return; }
        setSessoes(r.sessoes || []);
    }

    async function revogar(token, login, apelido) {
        const c = await Swal.fire({
            icon: 'warning',
            title: 'Revogar sessao?',
            html: `Login: <b>${login}</b><br>Maquina: <b>${apelido || '-'}</b><br><br>O usuario precisara fazer login novamente nessa maquina.`,
            showCancelButton: true,
            confirmButtonText: 'Revogar',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#a73838',
        });
        if (!c.isConfirmed) return;
        const r = await RevogaSessaoMemoria({ solicitante: me?.email, token });
        if (r.Error) return Swal.fire({ icon: 'warning', title: 'Erro', text: r.Error });
        Swal.fire({ icon: 'success', title: 'Sessao revogada', timer: 1200, showConfirmButton: false });
        carregar();
    }

    async function revogarTodas(login) {
        const c = await Swal.fire({
            icon: 'warning',
            title: 'Revogar TODAS as sessoes?',
            html: `Login: <b>${login}</b><br><br>Todas as maquinas onde esse usuario estiver logado serao desconectadas.`,
            showCancelButton: true,
            confirmButtonText: 'Revogar todas',
            cancelButtonText: 'Cancelar',
            confirmButtonColor: '#a73838',
        });
        if (!c.isConfirmed) return;
        const r = await RevogaSessaoMemoria({ solicitante: me?.email, login, todas: true });
        if (r.Error) return Swal.fire({ icon: 'warning', title: 'Erro', text: r.Error });
        Swal.fire({ icon: 'success', title: `Revogadas: ${r.revogadas || 0}`, timer: 1500, showConfirmButton: false });
        carregar();
    }

    const visiveis = filtroAtivos ? sessoes.filter(s => s.ativo) : sessoes;

    // Agrupa por login
    const grupos = {};
    visiveis.forEach(s => {
        const k = s.login || 'sem-login';
        if (!grupos[k]) grupos[k] = [];
        grupos[k].push(s);
    });
    const logins = Object.keys(grupos).sort();

    return (
        <div className="page">
            <div className="page-head">
                <div>
                    <div className="eyebrow"><span className="num ti">TI</span> Sessoes da Memoria</div>
                    <h1 className="page-title">Sessoes da Memoria</h1>
                    <p className="page-sub">Tokens ativos no conector Memoria Babita. Cada linha e uma maquina onde o usuario fez login.</p>
                </div>
                <div style={{ display: 'flex', gap: 8 }}>
                    <button className="btn" onClick={carregar} disabled={carregando}>
                        {carregando ? 'Atualizando...' : 'Atualizar'}
                    </button>
                </div>
            </div>

            <div className="kpi-strip">
                <div className="kpi-cell"><div className="kpi-label">Sessoes ativas</div><div className="kpi-val">{sessoes.filter(s => s.ativo).length}</div></div>
                <div className="kpi-cell"><div className="kpi-label">Total registradas</div><div className="kpi-val">{sessoes.length}</div></div>
                <div className="kpi-cell"><div className="kpi-label">Usuarios unicos</div><div className="kpi-val">{new Set(sessoes.map(s => s.login)).size}</div></div>
                <div className="kpi-cell">
                    <div className="kpi-label">Filtro</div>
                    <div className="kpi-val" style={{ fontSize: 14 }}>
                        <label style={{ cursor: 'pointer' }}>
                            <input type="checkbox" checked={filtroAtivos} onChange={e => setFiltroAtivos(e.target.checked)} />
                            &nbsp;So ativas
                        </label>
                    </div>
                </div>
            </div>

            {erro && (
                <div className="card flat" style={{ marginTop: 16, padding: 16, background: '#fde8e8', border: '1px solid #f5c6c6' }}>
                    <strong>Erro:</strong> {erro}
                </div>
            )}

            {!erro && logins.length === 0 && !carregando && (
                <div className="muted" style={{ padding: 24 }}>Nenhuma sessao encontrada.</div>
            )}

            {logins.map(login => (
                <div key={login} className="card flat" style={{ marginTop: 16, padding: 0 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '14px 18px', borderBottom: '1px solid var(--line)' }}>
                        <div>
                            <strong>{login}</strong>
                            {grupos[login][0]?.cargo && <span className="muted">&nbsp;&middot; {grupos[login][0].cargo}/{grupos[login][0].setor}</span>}
                            <span className="muted">&nbsp;&middot; {grupos[login].length} sessao(oes)</span>
                        </div>
                        <button
                            className="btn"
                            onClick={() => revogarTodas(login)}
                            style={{ background: 'transparent', color: '#a73838', border: '1px solid #a73838', padding: '4px 12px' }}>
                            Revogar todas
                        </button>
                    </div>
                    <table className="perm-matrix" style={{ width: '100%' }}>
                        <thead>
                            <tr>
                                <th style={{ textAlign: 'left' }}>Apelido / Maquina</th>
                                <th style={{ textAlign: 'left' }}>IP</th>
                                <th>Criado</th>
                                <th>Ultimo uso</th>
                                <th>Status</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {grupos[login].map(s => (
                                <tr key={s.token_id}>
                                    <td className="label">
                                        <div>{s.apelido || '(sem apelido)'}</div>
                                        <div className="mono muted" style={{ fontSize: 11 }}>{s.token_preview}</div>
                                    </td>
                                    <td className="mono">{s.ip || '-'}</td>
                                    <td title={tempo(s.criado_em)}>{relativo(s.criado_em)}</td>
                                    <td title={tempo(s.ultimo_uso)}>{relativo(s.ultimo_uso)}</td>
                                    <td style={{ textAlign: 'center' }}>
                                        {s.ativo
                                            ? <span style={{ color: '#1d7a3a', fontWeight: 600 }}>Ativa</span>
                                            : <span className="muted">Revogada</span>}
                                    </td>
                                    <td style={{ textAlign: 'right' }}>
                                        {s.ativo && (
                                            <button
                                                className="btn"
                                                onClick={() => revogar(s.token_id, s.login, s.apelido)}
                                                style={{ background: 'transparent', color: '#a73838', border: '1px solid #a73838', padding: '2px 10px', fontSize: 12 }}>
                                                Revogar
                                            </button>
                                        )}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            ))}

            <div className="card flat" style={{ marginTop: 24, padding: '18px 22px' }}>
                <div className="eyebrow" style={{ marginBottom: 8 }}><span className="num">i</span> Como funciona</div>
                <p style={{ fontSize: 12.5, color: 'var(--ink-soft)', lineHeight: 1.7, margin: 0 }}>
                    Cada vez que um usuario faz login na memoria por uma maquina, o conector cria uma sessao identificada por apelido + IP.
                    Os tokens nao expiram. Para tirar o acesso de uma maquina, clique em <strong>Revogar</strong>. Para tirar de todas as maquinas
                    daquele usuario, clique em <strong>Revogar todas</strong>. O usuario precisara fazer login novamente.
                </p>
            </div>
        </div>
    );
}
